import { render, staticRenderFns } from "./FlyRewards.vue?vue&type=template&id=8af3bac6&"
import script from "./FlyRewards.vue?vue&type=script&lang=js&"
export * from "./FlyRewards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports